import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { ArrayMaxSize, ArrayNotEmpty, IsArray, IsUUID } from 'class-validator';
import { JobPhasePaidBatchInterface } from '../interfaces/job-phase-paid-batch.interface';

/** Upper bound of one "Mark as Paid" run; a Select all over a filtered sheet must fit. */
export const JOB_PHASE_PAID_BATCH_MAX_ITEMS = 1000;

export class JobPhasePaidBatchDto implements JobPhasePaidBatchInterface {
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    isArray: true,
    title: 'Job Phase IDs',
    description: 'Job phases to mark as paid. Rows already paid are skipped.',
    maxItems: JOB_PHASE_PAID_BATCH_MAX_ITEMS,
  })
  @Expose()
  @IsArray()
  @ArrayNotEmpty({ message: 'Select at least one row to mark as paid.' })
  @ArrayMaxSize(JOB_PHASE_PAID_BATCH_MAX_ITEMS, {
    message: `Too many rows selected to be processed (limit: ${JOB_PHASE_PAID_BATCH_MAX_ITEMS} rows).`,
  })
  @IsUUID('all', { each: true })
  jobPhaseIds!: string[];
}
